import type { CharacterLimitHookOptions, CharacterLimitHookReturn } from './types';

export function countCharacters(
    text: string,
    { limit, ignoreCharacters }: CharacterLimitHookOptions,
): CharacterLimitHookReturn {
    const textToCount = ignoreCharacters ? text.replace(ignoreCharacters, '') : text;
    const count = textToCount.length;

    return {
        count,
        remaining: limit - count,
    };
}

export type CharacterLimitHookArgs = Parameters<typeof countCharacters>;

export function useCharacterLimit(...args: CharacterLimitHookArgs): CharacterLimitHookReturn {
    return countCharacters(...args);
}
